<script>
export default {
  filters: {
    formatJson(value) {
      if (!value) return value;
      try {
        return JSON.stringify(JSON.parse(value), null, '  ');
      } catch (err) {
        console.warn('Failed to formatJson, returning original. Value was:', value);
        return value;
      }
    },

    descriptionFromAction(action) {
      if (!action) return action;

      switch (action) {
        case 'Alerts.Dismiss': return 'Alert was dismissed';

        case 'Broilers.AddBatch': return 'Broiler Batch added';
        case 'Broilers.AddButcheryRecord': return 'Butchery Record added to Broiler Batch';
        case 'Broilers.AddDailyRecord': return 'Daily Record added to Broiler Batch';
        case 'Broilers.AddFeedRecord': return 'Broiler Feed Record added';
        case 'Broilers.AddSlaughterRecord': return 'Slaughter Record added to Broiler Batch';
        case 'Broilers.DeleteButcheryRecord': return 'Butchery Record deleted from Broiler Batch';
        case 'Broilers.DeleteDailyRecord': return 'Daily Record deleted from Broiler Batch';
        case 'Broilers.DeleteSlaughterRecord': return 'Slaughter Record deleted from Broiler Batch';
        case 'Broilers.ImportBatch': return 'Broiler Batch imported';
        case 'Broilers.UpdateDailyRecord': return 'Daily Record updated of Broiler Batch';
        case 'Broilers.Food.AddFeedRecord': return 'Feed Record Added';

        case 'Layers.AddBatch': return 'Layer Batch added';
        case 'Layers.AddChickenWeightRecord': return 'Chicken Weight Record added to Layer Batch';
        case 'Layers.AddCollectionRecord': return 'Collection Record added to Layer Batch';
        case 'Layers.AddFoodBucketsRecord': return 'Layer Food Buckets Record added';
        case 'Layers.AddPackingRecord': return 'Packing Record added to Layer Batch';
        case 'Layers.PelletFood.AddPelletFood': return 'Layer Pellet Food Record added';
        case 'Layers.BulkImportCollectionRecords': return 'Collection Records bulk imported into Layer Batch';
        case 'Layers.BulkImportPackingRecords': return 'Packing Records bulk imported to Layer Batch';
        case 'Layers.ImportBatch': return 'Layer Batch imported';
        case 'Layers.Order.SaveOrder': return 'Layer Egg Order Updated';
        case 'Layers.Order.Add': return 'Layer Egg Order Added';
        case 'Layers.Order.FinalizeOrder': return 'Layer Egg Order Finalized';
        case 'Layers.Order.CompleteOrder': return 'Layer Egg Order Completed';
        case 'Layers.CurrentStock.AddPackedStockIn': return 'Layer added Packed Stock In';
        case 'Layers.CurrentStock.DoStockCount': return 'Layer Stock Counted';
        case 'Layers.BucketsFood.AddFoodBucketsRecord': return 'Layer added Food Buckets Record';

        case 'Tenant.AddAdminRecipient': return 'Tenant Admin Recipient added';
        case 'Tenant.DeleteAdminRecipient': return 'Tenant Admin Recipient deleted';

        default:
          console.warn(`Audit action ${action} has no friendly description`)
          return action;
      }
    }
  },

  props: {
    records: { type: Array, required: true },
  },

  data: () => ({
    selectedOldValueRecord: undefined,
    selectedNewValueRecord: undefined,
  }),

  methods: {
    toggleOldValue(record) {
      this.selectedOldValueRecord = this.selectedOldValueRecord === record ? undefined : record;
    },
    toggleNewValue(record) {
      this.selectedNewValueRecord = this.selectedNewValueRecord === record ? undefined : record;
    },
  },
}
</script>

<template>
  <b-list-group flush>
    <!-- <b-list-group-item v-for="record in records" :key="record.id" v-once> -->
    <b-list-group-item v-for="record in records" :key="record.id">

      <div class="d-flex">
        <div>
          <div class="h4 mb-0"> {{record.action | descriptionFromAction}} </div>
          <div class="mb-2 small text-muted"> {{record.entity_description}} </div>
        </div>

        <div class="ml-auto">
          <div class="small text-muted"> {{record.audit_date}} </div>

          <b-badge variant="secondary"> <i class="fa fa-user"></i> {{record.person_name}} </b-badge>
          <b-badge variant="dark"> <i class="fa fa-chain"></i> {{record.actor_ip}} </b-badge>
        </div>
      </div>

      <!-- <div> {{record.entity_id}} </div> -->

      <div v-if="record.old_value">
        <i :class="[selectedOldValueRecord === record ? 'fa fa-chevron-down' : 'fa fa-chevron-right']"></i>

        <a href="javascript:void(0)" @click="toggleOldValue(record)">
          {{selectedOldValueRecord === record ? 'Hide old value' : 'Show old value'}}
        </a>

        <pre v-if="selectedOldValueRecord === record" class="text-muted">{{record.old_value | formatJson}}</pre>
      </div>

      <div v-if="record.new_value">
        <i :class="[selectedNewValueRecord === record ? 'fa fa-chevron-down' : 'fa fa-chevron-right']"></i>

        <a href="javascript:void(0)" @click="toggleNewValue(record)">
          {{selectedNewValueRecord === record ? 'Hide new value' : 'Show new value'}}
        </a>

        <pre v-if="selectedNewValueRecord === record" class="text-success">{{record.new_value | formatJson}}</pre>
      </div>

    </b-list-group-item>
  </b-list-group>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/components/AuditRecordsListGroup.vue